<template>
  <div>
    <div class="search-container mb4">
      <div class="w-flex align-center">
        <w-input
          class="grow"
          label="Carian"
          v-model="searchQuery"
          @input="performSearch"
          placeholder="Masukkan kata kunci untuk mencari..."
          prepend-inner-icon="fal fa-search"
        />
        <w-button 
          class="ml2" 
          bg-color="primary" 
          @click="clearSearch"
          v-if="searchQuery"
        >
          <w-icon>fal fa-times</w-icon>
        </w-button>
      </div>
    </div>

    <div class="w-table w-table--wrap">
      <div class="w-table__scroll-wrap">
        <table class="w-table" color="light">
          <thead>
            <tr>
              <th class="w-table__header text-center" width="1%">No</th>
              <th class="w-table__header text-center">Jenis Ternakan</th>
              <th class="w-table__header text-center">No Pendaftaran</th>
              <th class="w-table__header text-center">ID | Nama Ternakan</th>
              <th class="w-table__header text-center">Baka</th>
              <th class="w-table__header text-center">Jurusan Ternakan</th>
              <th class="w-table__header text-center">Jantina</th>
              <th class="w-table__header text-center">Tarikh lahir</th>
              <th class="w-table__header text-center">Status</th>
              <th class="w-table__header text-center" width="1%">Tindakan</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredDatas.length === 0" class="w-table__row">
              <td class="w-table__cell text-left" colspan="10">
                {{ searchQuery ? 'Tiada hasil carian.' : 'Tiada Data.' }}
              </td>
            </tr>

            <tr v-for="(dt, ind) in filteredDatas" :key="dt.id_ternakan" class="w-table__row">
              <td class="w-table__cell text-center" style="padding-top:10px">{{ ind + 1 }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.species }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.kode }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.id_ternakan }} | {{ dt.nama }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.breed }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.jurusan }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.sex }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">{{ dt.status }}</td>
              <td class="w-table__cell text-center" style="padding-top:10px">
                <w-tooltip md top color="white" bg-color="black" v-if="dt.bunting != 1">
                  <template #activator="{ on }">
                    <w-button bg-color="info" v-on="on" @click="copy(dt)" class="be fs-2">
                      <div style="width: 8px"></div>
                      <w-icon md class="mr2">fal fa-copy</w-icon>
                    </w-button>
                  </template>
                  SALIN
                </w-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width || '50%'"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white"
    >
      <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        {{ dialog.title }}
      </template> 
      
      <w-form 
        ref="form" 
        v-model:errors-count="form.errorsCount"
        v-model="dialog.valid"
        @validate="simpan"
        @success="success">
        
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <w-flex wrap :gap="2">
              <div class="mb4" style="min-width: 200px; flex: 1;">
                <z-select 
                  class="mt4" 
                  :items="premis" 
                  label="Premis *" 
                  v-model="form.premis_id" 
                  :validators="[validators.required]" 
                  @input="changePremis(form)"
                />
                
                <div class="input-group">
                  <template v-if="form.nama == ''">
                    <w-input
                      class="mt2"
                      label="ID Ternakan (No Tag)"
                      type="text"
                      v-model="form.id_ternakan"
                      :validators="[validators.required]"
                    />
                  </template>
                  <template v-else>
                    <w-input
                      class="mt2"
                      label="ID Ternakan (No Tag)"
                      type="text"
                      v-model="form.id_ternakan"
                    />
                  </template>
                  
                  <template v-if="form.id_ternakan == ''">
                    <w-input
                      class="mt4"
                      label="Nama Ternakan"
                      type="text"
                      v-model="form.nama"
                      :validators="[validators.required]"
                    />
                  </template>
                  <template v-else>
                    <w-input
                      class="mt4"
                      label="Nama Ternakan"
                      type="text"
                      v-model="form.nama"
                    />
                  </template>
                  
                  <span class="input-hint">**Sila isi salah satu ID Ternakan atau Nama Ternakan</span>
                </div>
                
                <w-input 
                  class="mt4" 
                  label="Tarikh Lahir *" 
                  type="date" 
                  v-model="form.tarikh_lahir" 
                  :validators="[validators.required]"
                />
                
                <z-select 
                  class="mt4" 
                  :items="jantina" 
                  label="Jantina *" 
                  v-model="form.jantina" 
                  :validators="[validators.required]"
                />
                
                <template v-if="form.jantina == 2">
                  <div class="pregnancy-status" v-if="form.id > 0">
                    <b>Bunting : </b>
                    <w-radios 
                      class="mr2" 
                      v-model="form.bunting" 
                      :items="bunting_list" 
                      inline 
                      color="blue-light1"
                    />
                  </div>
                </template>

                <z-select 
                  class="mt4" 
                  :items="lkp_ternakan" 
                  label="Jenis Ternakan *" 
                  v-model="form.lkp_ternakan_id" 
                  @input="getJurusan(form.lkp_ternakan_id)" 
                  :validators="[validators.required]"
                />
                <z-select 
                    class="mt4" 
                    :items="lkp_jurusan" 
                    label="Jurusan Ternakan *"  
                    v-model="form.lkp_jurusan_id" 
                    @input="getBaka(form.lkp_jurusan_id)" 
                    :validators="[validators.required]"
                  />
                <z-select 
                  class="mt4" 
                  :items="lkp_status" 
                  label="Status *" 
                  v-model="form.lkp_status_id" 
                  :validators="[validators.required]" 
                  v-if="form.id > 0"
                />
              </div>
              
              <div class="mb4" style="min-width: 200px; flex: 1;">
                <z-select
                  class="mt4"
                  :items="lkp_baka"
                  label="Baka *"
                  v-model="form.lkp_baka_id"
                  :validators="[validators.required]"
                />
                <z-select 
                  class="mt4" 
                  :items="lkp_gred" 
                  label="Generasi *" 
                  v-model="form.lkp_gred_id" 
                  :validators="[validators.required]"
                />
                <z-select class="mt4"  v-model="form.lkp_warna_id" :items="lkp_warna" label="Warna Bulu" />
                <w-input class="mt4" label="Nama Bapa" type="text" v-model="form.nama_bapa" />
                <w-input class="mt4" label="ID Bapa" type="text" v-model="form.id_bapa" />
                <w-input class="mt4" label="Nama Ibu" type="text" v-model="form.nama_ibu" />
                <w-input class="mt4" label="ID Ibu" type="text" v-model="form.id_ibu" />
                <z-select 
                    class="mt4" 
                    :items="lkp_kaedah_pembiakan" 
                    label="Kaedah Pembiakan"  
                    v-model="form.lkp_kaedah_pembiakan_id"  
                    disabled
                  />
                <z-select 
                  class="mt4" 
                  :items="status_ternakan" 
                  label="Status Ternakan Baka" 
                  v-model="form.status_ternakan" 
                  v-if="form.id > 0"
                  disabled
                />
              </div>
            </w-flex>
          </div>
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                background-color: #f0f0f0; 
                border: 2px solid red; 
                color: #333; 
                padding: 7px 14px; 
                font-size: 10px; 
                font-weight: bold; 
                border-radius: 4px; 
                cursor: pointer;
            " @click="dialog.show = false">
          TUTUP
        </w-button>
        <w-button 
          class="ml1" 
          :loading="dialog.loading"
          :disabled="dialog.loading || dialog.valid === false"
          @click="$refs.form.validate()"
        >
          {{ dialog.loading ? 'MENYIMPAN...' : 'SIMPAN' }}
        </w-button>
      </template>
    </w-dialog>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props: {
    data: [Array, Object],
  },
  data() {
    return {
      datas: [],
      filteredDatas: [], 
      searchQuery: '', 

      dialog: {
        show: false,
        title: '',
        valid: false,
        loading: false,
        width: '50%',
        fullscreen: false,
        persistent: false,
        persistentNoAnimation: false
      },

      form: {
        id: 0,
        premis_id: '',
        lkp_ternakan_id: '',
        lkp_baka_id: '',
        lkp_kaedah_pembiakan_id: 3,
        lkp_gred_id: '',
        lkp_warna_id: '',
        kode: '',
        nama: '',
        id_ternakan: '',
        tarikh_lahir: '',
        jantina: '',
        lkp_jurusan_id: '',
        lkp_status_id: '',
        status_ternakan: '',
        nama_bapa: '',
        id_bapa: '',
        nama_ibu: '',
        id_ibu: '',
        warna: '',
        bunting: null,
        copy: 0
      },

      lkp_jurusan: [],
      lkp_ternakan: [],
      lkp_baka: [],
      lkp_kaedah_pembiakan: [],
      premis: [],
      lkp_gred: [],
      lkp_warna: [],
      lkp_status: [],
      status_ternakan: [],
      jantina: [],
      bunting_list: [
        {value: 1, label: "YA"},
        {value: null, label: "TIDAK"},
      ],
      id_premis_sebelum: 0,
      validators: {
        required: value => !!value || 'Diperlukan'
      }
    }
  },
  methods: {
    
    performSearch() {
      if (!this.searchQuery) {
        this.filteredDatas = [...this.datas];
        return;
      }
      
      const query = this.searchQuery.toLowerCase();
      this.filteredDatas = this.datas.filter(item => {
        return (
          (item.species && item.species.toLowerCase().includes(query)) ||
          (item.kode && item.kode.toLowerCase().includes(query)) ||
          (item.id_ternakan && item.id_ternakan.toLowerCase().includes(query)) ||
          (item.nama && item.nama.toLowerCase().includes(query)) ||
          (item.breed && item.breed.toLowerCase().includes(query)) ||
          (item.jurusan && item.jurusan.toLowerCase().includes(query)) ||
          (item.sex && item.sex.toLowerCase().includes(query)) ||
          (item.status && item.status.toLowerCase().includes(query))
        );
      });
    },
    
    clearSearch() {
      this.searchQuery = '';
      this.performSearch();
    },
    
    getData() {
      this.$zcomm.get(this.api_service + 'premis/ternakanSmart/' + this.data.id, {}).then(res => {
        this.datas = res.d || [];
        this.filteredDatas = [...this.datas];
      })
    },
    
    edit(item) {
      this.form = {
        id: item.id ?? 0,
        premis_id: item.premis_id ?? '',
        lkp_ternakan_id: item.lkp_ternakan_id ?? '',
        lkp_baka_id: item.lkp_baka_id ?? '',
        lkp_kaedah_pembiakan_id: item.lkp_kaedah_pembiakan_id ?? 3,
        lkp_gred_id: item.lkp_gred_id ?? '',
        lkp_warna_id: item.lkp_warna_id ?? '',
        kode: item.kode ?? '',
        nama: item.nama ?? '',
        id_ternakan: item.id_ternakan ?? '',
        tarikh_lahir: item.tarikh_lahir ?? '',
        jantina: item.jantina ?? '', 
        lkp_jurusan_id: item.lkp_jurusan_id ?? '',
        lkp_status_id: item.lkp_status_id ?? '',
        status_ternakan: item.status_ternakan ?? '',
        nama_bapa: item.nama_bapa ?? '',
        id_bapa: item.id_bapa ?? '',
        nama_ibu: item.nama_ibu ?? '',
        id_ibu: item.id_ibu ?? '',
        warna: item.warna ?? '',
        bunting: item.bunting ?? null,
        copy: 0
      }

      this.dialog.show = true
      this.dialog.title = 'Kemaskini'
      this.id_premis_sebelum = item.premis_id

      if (this.form.lkp_ternakan_id) {
        this.getJurusan(this.form.lkp_ternakan_id)
      }

      if (this.form.lkp_jurusan_id) {
        this.getBaka(this.form.lkp_jurusan_id)
      }
    },
    
    
    copy(item) {
      this.form = {
        id: 0, 
        premis_id: item.premis_id ?? '',
        lkp_ternakan_id: item.lkp_ternakan_id ?? '',
        lkp_baka_id: item.lkp_baka_id ?? '',
        lkp_kaedah_pembiakan_id: item.lkp_kaedah_pembiakan_id ?? 3,
        lkp_gred_id: item.lkp_gred_id ?? '',
        lkp_warna_id: item.lkp_warna_id ?? '',
        kode: '',
        nama: '', 
        id_ternakan: item.id_ternakan ?? '', 
        tarikh_lahir: item.tarikh_lahir ?? '',
        jantina: item.jantina ?? (item.sex == 'FEMALE' ? 2 : 1), 
        lkp_jurusan_id: item.lkp_jurusan_id ?? '',
        lkp_status_id: '', 
        status_ternakan: item.status_ternakan ?? '',
        nama_bapa: item.nama_bapa ?? '',
        id_bapa: item.id_bapa ?? '',
        nama_ibu: item.nama_ibu ?? '',
        id_ibu: item.id_ibu ?? '',
        warna: item.warna ?? '',
        bunting: item.bunting ?? null,
        copy: 1 
      }

      this.dialog.show = true
      this.dialog.title = 'Salin'
      this.id_premis_sebelum = item.premis_id

      if (this.form.lkp_ternakan_id) {
        this.getJurusan(this.form.lkp_ternakan_id)
      }

      if (this.form.lkp_jurusan_id) {
        this.getBaka(this.form.lkp_jurusan_id)
      }
    },
    
    simpan() {
      this.dialog.loading = true
      if (this.dialog.valid == true) {
        if (this.form.id > 0 || this.form.copy === 1) {
          this.$zcomm.post('daftar.ternakan.store', this.form)
            .then(res => {
              this.dialog.loading = false
              this.dialog.show = false
              this.getData()  
              this.$inertia.visit(this.$page.url)
            })
            .catch(error => {
              this.dialog.loading = false
              console.error("Error saving data:", error);
            })
        }
      } else {
        this.dialog.loading = false
      }
    },
    
    success() {
    },
    
    getJurusan(i) {
      this.$zcomm.get(this.api_service + 'lookup/jurusan/' + i, {}).then(res => {
        this.lkp_jurusan = res
      })
    },
    
    getBaka(i) {
      this.$zcomm.get(this.api_service + 'lookup/baka/' + i, {}).then(res => {
        this.lkp_baka = res
      })
    },
    
    getPremis() {
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
      })
    },
    
    getJantina() {
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },
    
    getTernakan() {
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },
    
    getGred() {
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
      })
    },
    
    getWarna() {
      this.$zcomm.get(this.api_service + 'lookup/warna', {}).then(res => {
        this.lkp_warna = res
      })
    },
    
    getStatus() {
      this.$zcomm.get(this.api_service + 'lookup/status_te', {}).then(res => {
        this.lkp_status = res
      })
    },
    
    getStatusTernak() {
      this.$zcomm.get(this.api_service + 'lookup/status_ternak', {}).then(res => {
        this.status_ternakan = res
      })
    },
    
    getKaedahPembiakan() {
      this.$zcomm.get(this.api_service + 'lookup/kaedah_pembiakan', {}).then(res => {
        this.lkp_kaedah_pembiakan = res
      })
    },
    
    changePremis(form) {
      if (form.id > 0) {
        if (this.id_premis_sebelum == form.premis_id) {
          form.status_ternakan = 0;
        } else {
          form.status_ternakan = 41;
        }
      }
    },
  },
  mounted() {
    this.getData();
    this.getPremis();
    this.getJantina();
    this.getTernakan();
    this.getGred();
    this.getStatus();
    this.getStatusTernak();
    this.getKaedahPembiakan();
    this.getWarna();
  }
}
</script>

<style scoped>

.search-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}


.w-pagination-numbers {
  display: flex;
  align-items: center;
  gap: 4px; 
}

.nav-button {
  background-color: #f0f0f0 !important;
  color: #333 !important;
  border: 1px solid #ddd !important;
  height: 30px !important;      
  min-width: 30px !important;   
  padding: 0 6px !important;    
}

.nav-button .w-icon {
  font-size: 0.9em;
}

.nav-button:hover:not(:disabled) {
  background-color: #e0e0e0 !important;
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-number-button {
  min-width: 30px !important;   
  height: 30px !important;      
  padding: 0 6px !important;   
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 4px !important;
  background-color: #f0f0f0 !important;
  color: #333 !important;
  border: 1px solid #ddd !important;
  font-weight: 500;
  font-size: 0.9em;            
}

.page-number-button:hover {
  background-color: #e0e0e0 !important;
}

.page-number-button.active-page {
  background-color: #1976d2 !important; 
  color: white !important;
  border-color: #1976d2 !important;
}

.pagination-info {
  font-size: 0.9em;
  color: #666;
}

.input-group {
  border: 1px solid #000;
  border-radius: 4px;
  padding: 10px;
  margin-top: 16px;
  background-color: #f9f9f9;
}

.input-hint {
  color: red;
  font-size: 0.8em;
  display: block;
  margin-top: 8px;
}

.pregnancy-status {
  margin-top: 10px;
  padding-right: 20px;
  color: #234781;
  font-weight: normal;
  font-size: 1rem;
}
</style>